import { NavigateFunction } from "react-router-dom";

class NavigationService {
	private navigate: NavigateFunction | null = null;

	setNavigate(navigate: NavigateFunction) {
		this.navigate = navigate;
	}

	navigateTo(path: string) {
		if (this.navigate) {
			this.navigate(path);
		} else {
			// Fallback to window.location if navigate is not set
			console.warn("Navigation service not initialized, falling back to window.location");
			window.location.href = path;
		}
	}

	isInitialized() {
		return this.navigate !== null;
	}
}

// Export singleton instance
export const navigationService = new NavigationService();